
import {
  defineComponent,
  defineAsyncComponent,
  computed,
  onMounted,
  ref,
  Component,
  reactive
} from 'vue'
import { useRoute, useRouter } from 'vue-router';
import {
  Notify,
  Field,
  CellGroup,
  Uploader,
  Image,
  DatetimePicker,
  Popup,
  Cell,
  Toast,
  Button,
  Icon,
  Dialog,
  Search,
  Checkbox,
  CheckboxGroup
} from 'vant'
import Account from '@/api/account'
import base from "@/api/base";
import { checkIdCard } from '@/utils/main'
import dayjs from 'dayjs'
import axios from 'axios'
import qs from 'qs'
import OSS from 'ali-oss'
export default defineComponent({
  name: 'Index',
  props: {},
  data() {
    return {
      isplate: false,
      isshow: false,
      imageSrc: '',
      itemDate: '请选择预约时间'
      // minDate: new Date(2020, 0, 1),
      // maxDate: new Date(2099, 10, 1)
    }
  },
  components: {
    'van-field': Field,
    'van-cell-group': CellGroup,
    'van-uploader': Uploader,
    'van-image': Image,
    'van-datetime-picker': DatetimePicker,
    'van-popup': Popup,
    'van-cell': Cell,
    'van-button': Button,
    'van-icon': Icon,
    'van-search': Search,
    'van-checkbox': Checkbox,
    'van-checkbox-group': CheckboxGroup,
    'plate-number': defineAsyncComponent(() =>
      import('@/components/plateNumber.vue')
    ),
    surveyed: defineAsyncComponent(() => import('@/components/surveyed.vue'))
  },
  setup(props, ctx) {
    const pageNo = ref(1);
    const pageSize = ref(20);
    const isLastPage = ref(false);
    const teacherListLoading = ref(false);
    const search = ref('')
    const username = ref('')
    const phone = ref('')
    const phones = ref('')
    const message = ref('')
    const imageSrc = ref('')
    const idCard = ref('')
    const count = ref('')
    const unit = ref('')
    const mobile = ref('')
    const idCards = ref('')
    const token = ref()
    const platenumbre = ref('')
    const isSurveyed = ref(false)
    const isCheck = ref(false)
    const agree = ref()
    const route = useRoute()
    const router = useRouter()
    const audit = reactive({
      audit_level: 0,
      audit_status: 0
    })
    const teacherList = ref([])
    const codeList = ref([])
    const school_id = ref('')
    const school_type = ref('1')
    const user_name = ref('')
    const user_tel = ref('')
    let item = reactive({
      user_serial: -1,
      user_name: '',
      user_tel: ''
    })
    const schoolInfo = ref()

    const currentDate = ref(new Date())
    const currentYearDate = new Date()
    const prevYearDate = new Date(currentYearDate) // 复制当前时间，避免修改原对象
    prevYearDate.setFullYear(currentYearDate.getFullYear() - 1) // 年份减 1
    const nextYearDate = new Date(currentYearDate) // 复制当前时间，避免修改原对象
    nextYearDate.setFullYear(currentYearDate.getFullYear() + 1) // 年份减 1
    const minDate = ref(prevYearDate)
    const maxDate = ref(nextYearDate)
    //const envs = 'https://res-mal.12kcool.com/'
    const envs = ref(base.picHost)
    const imgSuffix = ref('?imageView2/0/w/500')
    const getToken = () => {
      if (schoolInfo.value.oss_type === 1) {
        getOssToken()
      } else if (schoolInfo.value.oss_type === 2) {
        getQiniuToken()
      }
    }
    // 获取阿里token
    const getOssToken = async (): Promise<void> => {
      // const [err, data]
      const data = await Account.getAliToken()
      token.value = data.data
    }
    // 获取七牛token
    const getQiniuToken = async (): Promise<void> => {
      // const [err, data]
      const data = await Account.getToken()
      console.log('getQiniuToken', data.data)
      token.value = data.data
    }
    const getSchoolConfig = async (): Promise<void> => {
      // const [err, data]
      const data = await Account.getConfig(school_id.value)
      schoolInfo.value = data.data || {}
      const { oss_type, oss_http_prefix } = schoolInfo.value
      envs.value = oss_http_prefix ? oss_http_prefix + '/' : base.picHost
      console.log('getSchoolConfig', schoolInfo.value);
      if (oss_type === 1) {
        getOssToken()
        imgSuffix.value = '?x-oss-process=image/resize,w_500'
      } else if (oss_type === 2) {
        getQiniuToken()
        imgSuffix.value = '?imageView2/0/w/500'
      }
    }

    const onIcon = (): void => {
      imageSrc.value = ''
    }


    const uploadImgToOss = async (file: any) => {
      Toast.loading({
        message: '上传中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })

      console.log('file', file, token.value);
      console.log('file', token.value, token);
      let key = randoms()
      const client = new OSS({
        region: schoolInfo.value.oss_region || 'oss-cn-zhangjiakou',
        accessKeyId: token.value.accessKeyId,
        accessKeySecret: token.value.accessKeySecret,
        stsToken: token.value.securityToken,
        bucket: schoolInfo.value.oss_bucket || 'xtyk12-test'
      })
      console.log('client', client);
      let res = null
      try {
        res = await client.put(key, file)
      } catch (error) {
        res = null
      }
      if (!res) {
        Toast.clear()
        getToken()
        Toast.fail('图片上传失败，请重新上传')
      }
      detects(res.name)
    }
    const uploadImgToQiniu = async (file: any) => {
      const axiosInstance = axios.create({ withCredentials: false }) //withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
      Toast.loading({
        message: '上传中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      const data = new FormData()
      data.append('token', token.value) //七牛需要的token，叫后台给，是七牛账号密码等组成的hash
      data.append('file', file)
      data.append('key', randoms())
      axiosInstance({
        method: 'POST',
        url: 'https://upload.qiniup.com/', //上传地址
        data: data,
        timeout: 30000, //超时时间，因为图片上传有可能需要很久
        onUploadProgress: progressEvent => {
          console.log(progressEvent)
        }
      })
        .then((data: any) => {
          console.log('uploadImgToQiniu', data);
          detects(data.data.key)
        })
        .catch(function (err) {
          console.log('uploadImgToQiniu', err);
          Toast.clear()
          getToken()
          Toast.fail('图片上传失败，请重新上传')
          //上传失败
        })
    }

    /**
     * 检测是否人脸
     */
    const detects = function (file: string) {
      console.log(imageSrc.value)
      Toast.clear()
      Toast.loading({
        message: '人脸检测中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      const url = `https://api-cn.faceplusplus.com/facepp/v3/detect`
      const data = {
        api_secret: base.faceSecret, // 正式key
        api_key: base.faceKey, // 正式key
        // api_secret: 'MuNDnbOZv1WM6G_tLoQW86miSE86Z5p2', // 试用key
        // api_key: 'dQh9L4PK32pC19YZm0EC-B4uTPnVZWON', // 试用key
        // image_url: schoolInfo.value.oss_http_prefix + '/' + file + '?imageView2/0/w/500',
        // image_url: envs.value + file,
        image_url: envs.value + file + imgSuffix.value,
        return_attributes: 'blur,headpose,eyestatus,mouthstatus,facequality'
      }
      axios({
        method: 'post',
        url: url, //上传地址
        data: qs.stringify(data),
        headers: {
          'content-type': 'application/x-www-form-urlencoded' // 默认值
        }
      }).then(response => {
        Toast.clear()
        const faces = response.data.faces
        console.log(response)
        if (faces.length === 0) {
          Notify('图片不合格，请重新拍摄')
        } else {
          const blurne = faces[0].attributes.blur.blurness
          const yaw_angle = faces[0].attributes.headpose.yaw_angle
          const eyeleft = faces[0].attributes.eyestatus.left_eye_status
          const eyeright = faces[0].attributes.eyestatus.right_eye_status
          const facequality = faces[0].attributes.facequality.value
          const mouthstatus = faces[0].attributes.mouthstatus
          if (1.5 < blurne.value) {
            Notify('图片太模糊，请重新拍摄')
            return
          }
          if (2 < eyeleft.occlusion || eyeright.occlusion > 2) {
            Notify('眼睛部位不合格，请重新拍摄')
            return
          }
          if (
            2 < mouthstatus.other_occlusion ||
            mouthstatus.surgical_mask_or_respirator > 2
          ) {
            Notify('嘴巴部位不合格，请重新拍摄')
            return
          }

          if (80 > facequality) {
            Notify('图片不合格，请重新拍摄')
            return
          }
          if (yaw_angle > 30 || yaw_angle < -30) {
            Notify('人脸没有朝向正前方，请重新拍摄')
            return
          }
          imageSrc.value = file
        }
      }).catch(err => {
        imageSrc.value = file
      })
    }

    const randoms = function () {
      const mun = []
      for (let i = 0; i < 10; i++) {
        mun.push(Math.floor(Math.random() * 10))
      }
      return (
        school_id.value + "/" + 'mobile' + '_' + mun.join('') + '_' + new Date().getTime() + '.jpg'
      )
    }
    const afterRead = function (file: any) {
      // 此时可以自行将文件上传至服务器
      console.log(file)
      if (schoolInfo.value.oss_type === 1) {
        uploadImgToOss(file.file)
      } else if (schoolInfo.value.oss_type === 2) {
        uploadImgToQiniu(file.file)
      }
    }
    const visitorAuditing = async (): Promise<void> => {
      const [err, data] = await Account.visitorAuditing(school_id.value)
      const list = data || {}
      audit.audit_level = list.audit_level
      audit.audit_status = list.audit_status
      if (audit.audit_level === 4) {
        get_teacher_list_new()
      }
      console.log(data)
    }

    const getCodeItem = async (): Promise<void> => {
      const [err, data] = await Account.getCodeItem({
        code_no: 'VR1001',
        school_id: school_id.value
      })
      codeList.value = data
      console.log(data)
    }
    const getQueryPictures = async (tel: string) => {
      if (imageSrc.value) return
      const [err, data] = await Account.getQueryPicture(tel)
      console.log(data)

      if (data) {
        imageSrc.value = data
      }
    }
    const refList=ref({finished:false})
    const get_teacher_list_new = async () => {
      const [err, data] = await Account.get_teacher_list_new({
        is_page: 1, // 分页
        page_num: pageNo.value,
        page_size: pageSize.value,
        school_id: school_id.value,
        dept_ids: -1,
        touser_type: 2, // 1：访客列表，2： 移动端列表
        user_duties:'1,2',
        user_name: search.value
      })
      data.list.map((item: { user_tel: string; user_tels: string }) => {
        if (item.user_tel) {
          item.user_tels = plusXingmobile(item.user_tel, 4, 3)
        }
      })
      if(data.list.length===0){
       Toast.fail('搜索人员不存在')
      }
      isLastPage.value = (pageNo.value * pageSize.value >= (data.total || 0))
      if(pageNo.value === 1){
        teacherList.value = data.list
      }else{
        if(Array.isArray(data.list)){
          teacherList.value = teacherList.value.concat(data.list)
        }
      }
    }

    const getCheck = () => {
      //if (audit.audit_status === 0) return addVisitorAuditing();
      if (audit.audit_level === 4) return (isSurveyed.value = true)
      const datas = {
        touser_name: user_name.value,
        touser_tel: user_tel.value
      }
      if (
        user_name.value === '' &&
        (audit.audit_level === 2 || audit.audit_level === 3)
      ) {
        Toast.fail('请输入被访人姓名')
        return true
      }
      if (
        user_tel.value === '' &&
        (audit.audit_level === 1 || audit.audit_level === 3)
      ) {
        Toast.fail('请输入被访人手机号')
        return true
      }
      Account.getCheck(audit.audit_level, school_id.value, datas)
        .then((response: any) => {
          const { code, msg, data } = response
          if (code == 1) {
            isCheck.value = false
          } else {
            isCheck.value = true
            if (data instanceof Array) {
              data.map((item: { user_tel: string; user_tels: string }) => {
                if (item.user_tel) {
                  item.user_tels = plusXingmobile(item.user_tel, 3, 4)
                }
              })
              if (teacherList.value.length > 0) {
                Toast('学校系统中存在多人重名的，请选择！')
                isSurveyed.value = true
              }
            } else {
              addVisitorAuditing()
            }
            teacherList.value = data
          }
        })
        .catch((err: any) => {
          console.log(err)
        })
    }

    const plusXingmobile = (str: string, frontLen: number, endLen: number) => {
      let tel = ''
      const len = str.length - frontLen - endLen
      let xing = ''
      for (let i = 0; i < len; i++) {
        xing += '*'
      }

      tel =
        str.substring(0, frontLen) + xing + str.substring(str.length - endLen)

      return tel
    }
    const setItem = (val: any) => {
      isCheck.value = true
      item = reactive(val)
      user_tel.value = item.user_tel
      user_name.value = item.user_name
      //addVisitorAuditing();
    }
    const addVisitorAuditing = async () => {
      console.log('facePrivatyState', facePrivatyState.value)
      if (imageSrc.value && facePrivatyState.value && !agree.value) {
        Toast.fail('请阅读并同意校园人脸服务协议')
        return false
      }
      
      if (!check()) return
      const datas: object = {
        visitor_name: username.value,
        identity_no: idCards.value,
        visitor_tel: phones.value,
        user_count: count.value,
        visitor_begin_time: currentDate.value,
        touser_id: item.user_serial,
        touser_name: user_name.value,
        touser_tel: user_tel.value,
        school_id: school_id.value,
        audit_status: audit.audit_status,
        audit_level: audit.audit_level,
        tour_status: 4,
        face_pics: imageSrc.value,
        visitor_car_no: platenumbre.value,
        visitor_reason: message.value,
        visitor_company: unit.value
      }

      if (audit.audit_status === 1) {
        Toast({
          message: '正在通知被访人，请稍候！\n 请勿关闭此页面',
          forbidClick: true,
          duration: 0
        })
      } else {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
      }

      //const [err, data] = await Account.addVisitorAuditing(datas);
      
      Account.addVisitorAuditing(datas).then((response: any) => {
        Toast.clear()
        const { code, msg, data } = response
        if (audit.audit_status === 1) {
          const setTimeoutid = setTimeout(() => {
            Toast.clear(false)
            clearTimeout(setTimeoutid)
          }, 2000)
        }
        console.log('addVisitorAuditing', data);

        // if (data?.msg) {
        //   Toast(data?.msg)
        // }
        if (code === 0) {
          if (facePrivatyState.value && imageSrc.value) {
            setProtocol({
              protocol_code: ['PTC_FACE'],
              user_role: 'SYS006',
              user_id: data?.id || '',
              user_tel: phones.value || '',
              status: 1,
              confirm_scene: 5,
              confirm_user: data?.id || '',
              school_id: school_id.value
            })
          }
          
          const { visit_protocol, visitor_roles } = schoolInfo.value || {}
          console.log('visit_protocol, visitor_roles', visit_protocol, visitor_roles);
          if (visit_protocol && visitor_roles.length) {
            setProtocol({
              protocol_code: ['PTC_VISITOR'],
              user_role: 'SYS006',
              user_id: data?.id || '',
              user_tel: phones.value || '',
              status: 1,
              confirm_scene: 5,
              confirm_user: data?.id || '',
              school_id: school_id.value
            })
          }
          Dialog.alert({
            message: data?.msg,
            theme: 'round-button'
          }).then(() => {
            // on close
            location.reload()
          })
        }
      }).catch((err:any) =>{
        Toast.clear()
      })
    }
    // 协议确认接口
    const setProtocol = async (data: any): Promise<void> => {
      // const [err, data]
      const res = await Account.setProtocol(data)
      console.log('setProtocol', res)
    }
    const check = (): boolean => {
      // if (getCheck()) {
      //   Toast.fail("请输入被访人信息");
      //   return false;
      // }
      if (username.value === '') {
        Toast.fail('请输入来访人姓名')
        return false
      }
      if (phones.value === '') {
        Toast.fail('请输入来访人手机号')
        return false
      }
      if (!/^[1][3-9][0-9]{9}$/.test(phones.value)) {
        Toast.fail('请输入正确的手机号')
        return false
      }
      if (count.value === '') {
        Toast.fail('请输入来访人数')
        return false
      }
      if (!/^\d+$/.test(count.value)) {
        Toast.fail('请输入正确的来访人数')
        return false
      }

      if (!checkIdCard(idCards.value)) {
        Toast.fail('请输入正确的身份证号')
        return false
      }
      if (message.value === '') {
        Toast.fail('请输入来访事由')
        return false
      }
      if (audit.audit_status === 1) {
        if (user_name.value == '' && audit.audit_level === 4) {
          Toast.fail('请选择被访人')
          return false
        }
        if (
          user_name.value == '' &&
          (audit.audit_level === 2 || audit.audit_level === 3)
        ) {
          Toast.fail('请输入被访人姓名')
          return false
        }
        if (
          user_tel.value == '' &&
          (audit.audit_level === 1 || audit.audit_level === 3)
        ) {
          Toast.fail('请输入被访人手机号')
          return false
        }
      }

      return true
    }
    const setSchoolByQuery = async (query: any) => {
      school_id.value = query.school_id
      school_type.value = query.school_type || '1'
    }

    const onSearch =  (e: any) => {
      console.log(search.value)
      pageNo.value=1
      get_teacher_list_new()
    }
    // 跳转服务协议
    const toProvaty = () => {
      console.log('toProvaty', router)
      router.push({
        path: '/webview',
        query: {
          school_type: school_type.value
        }
      });
      // router.push("/webview");
      // if (school_type.value === '2') {
      //   // window.location.href = 'https://www.12kcool.com/face-qiye.html'
      //   window.open('https://www.12kcool.com/face-qiye.html')
      // } else {
      //   // window.location.href = 'https://www.12kcool.com/face-school.html'
      //   window.open('https://www.12kcool.com/face-school.html')
      // }
    }
    const facePrivatyState = computed(() => {
      const { face_protocol, roles = [] } = schoolInfo.value || {}
      console.log('schoolInfo', schoolInfo.value, face_protocol, roles)
      if (face_protocol && roles.includes('SYS006')) {
        return true
      } else {
        return false
      }
    })
    onMounted(async () => {
      setSchoolByQuery(route.query)
      getSchoolConfig()
      visitorAuditing()
      getCodeItem()

      //const [err, data] = await Account.login({})
      // Notify('onMounteSSSd')
    })

    return {
      get_teacher_list_new,
      pageSize,
      pageNo,
      isLastPage,
      teacherListLoading,
      refList,
      onSearch,
      search,
      username,
      phone,
      phones,
      message,
      idCard,
      count,
      unit,
      mobile,
      idCards,
      token,
      afterRead,
      imageSrc,
      getQueryPictures,
      currentDate,
      minDate,
      maxDate,
      platenumbre,
      item,
      addVisitorAuditing,
      setItem,
      user_tel,
      user_name,
      school_id,
      school_type,
      setSchoolByQuery,
      visitorAuditing,
      onIcon,
      envs,
      imgSuffix,
      audit,
      getCheck,
      isSurveyed,
      teacherList,
      getCodeItem,
      codeList,
      isCheck,
      agree,
      schoolInfo,
      facePrivatyState,
      toProvaty,
      setProtocol,
    }
  },
  mounted() {
    // this.visitorAuditing()
    // this.getCodeItem()
  },
  methods: {
    async onLoadRemote(){
      if(this.isLastPage){
        return
      }
      this.pageNo += 1
      this.teacherListLoading = true
      await this.get_teacher_list_new()
      this.teacherListLoading = false
    },
    async onRefresh(){
      this.teacherListLoading = true
      this.pageNo = 1
      await this.get_teacher_list_new()
      this.teacherListLoading = false
    },
    onSurveyed() {
      if (this.audit.audit_status === 0) {
        this.isSurveyed = false
      } else if (this.audit.audit_level === 4) {
        this.isSurveyed = true
      }
    },

    getSurveyedList(data: any): void {
      this.isSurveyed = false

      this.setItem(data)
    },
    getPlateLicense(e: any) {
      console.log(e)
      this.platenumbre = e
      this.goplate()
    },
    asyncValidator(val: string) {
      console.log('asyncValidator', val)
    },
    validators(val: string) {
      if (!/^[1][3-9][0-9]{9}$/.test(val)) {
        Notify('请输入正确的手机号')
        return false
      }
      this.getQueryPictures(val)
      return this.plusXingmobile(val, 3, 4)
    },
    onphone() {
      this.phone = this.phones
    },
    onidcards() {
      this.idCard = this.idCards
    },
    plusXing(str: string, frontLen: number, endLen: number) {
      this.idCards = str
      if (!checkIdCard(this.idCards)) {
        Notify('请输入正确的身份证号')
        return false
      }
      const len = str.length - frontLen - endLen
      let xing = ''
      for (let i = 0; i < len; i++) {
        xing += '*'
      }

      this.idCard =
        str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
      return this.idCard
    },
    plusXingmobile(str: string, frontLen: number, endLen: number) {
      this.phones = str
      const len = str.length - frontLen - endLen
      let xing = ''
      for (let i = 0; i < len; i++) {
        xing += '*'
      }
      this.phone =
        str.substring(0, frontLen) + xing + str.substring(str.length - endLen)

      return this.phone
    },

    showPopup() {
      this.isshow = true
      console.log(this.isshow)
    },
    cancel() {
      this.isshow = false
    },
    confirm(e: any) {
      this.itemDate = dayjs(e).format('YYYY-MM-DD HH:mm')
      this.isshow = false
    },
    goplate() {
      this.isplate = !this.isplate
    }
  }
})
